import { render } from "./TarjetaHomeMejoresOfertas.vue?vue&type=template&id=bba70138&scoped=true"
import script from "./TarjetaHomeMejoresOfertas.vue?vue&type=script&lang=js"
export * from "./TarjetaHomeMejoresOfertas.vue?vue&type=script&lang=js"

import "./TarjetaHomeMejoresOfertas.vue?vue&type=style&index=0&id=bba70138&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bba70138"]])

export default __exports__